String.prototype.toSwe = function() {
    const encodingFixMap = {
        "|": "ö",
        "\\": "Ö",
        "#": "Ö",
        "{": "ä",
        "[": "Ä",
        "}": "å",
        "]": "Å"
    };

    return this
        .split("")
        .map(char => encodingFixMap[char] || char)
        .join("")
        .replace(/\s+$/, ""); // Trim trailing whitespace
};
